import Layout from '../../companyAdmin/layout.vue'
import Index from './index.vue'
import Editor from './editor.vue'

const basePath = '/v-admin/client-admin/school-management'

export default {
  path: `${basePath}`,
  redirect: `${basePath}/`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_ADMIN_SCHOOL_MANAGE'],
    menu: {
      labelI18nKey: 'admin.company.schoolManagement.menu'
    }
  },
  children: [
    {
      path: `${basePath}/`,
      component: Index,
      meta: {
        breadcrumb: { hidden: true },
        isNewPage: true,
        titleI18nKey: 'admin.company.schoolManagement.title',
        permission: ['PERM_ADMIN_SCHOOL_MANAGE']
      }
    },
    {
      path: `${basePath}/add`,
      component: Editor,
      meta: {
        isNewPage: true,
        titleI18nKey: 'admin.company.schoolManagement.label.addSchool',
        permission: ['PERM_ADMIN_SCHOOL_MANAGE']
      }
    },
    {
      path: `${basePath}/edit/:id`,
      component: Editor,
      meta: {
        isNewPage: true,
        isEdit: true,
        titleI18nKey: 'admin.company.schoolManagement.label.editSchool',
        permission: ['PERM_ADMIN_SCHOOL_MANAGE']
      }
    }
  ]
}
